

function toFixed(num){
	return num.div(10000).toString().match(/\d*\.?\d{0,2}/g)[0];
}

export default toFixed;